<template>
  <div class="page">
    <!-- <mobileHeader
      title="气瓶流转"
      rightType="none"
    /> -->
    <img v-if="BG == 'A0'" class="header-img" src="https://qiniu.yuncai-tech.com/share/material_a0.png" alt="" />
    <img v-if="BG == 'A8'" class="header-img" src="https://qiniu.yuncai-tech.com/share/material_a8.png" alt="" />
    <img v-if="BG == 'B0'" class="header-img" src="https://qiniu.yuncai-tech.com/share/material_b0.png" alt="" />
    <!-- <img class="header-img" src="@/assets/images/qipingchazhaoxinxi.png" alt="" /> -->
    <div class="content" :style="actItem == 2 ? 'height: calc(100vh - 21.5vw)' : 'height: fit-content; max-height: fit-content'">
      <!-- <img src="@/assets/images/bg-1.png" /> -->
      <div class="bg"></div>
      <div class="tab-box">
        <div :class="actItem == 1 && 'actItem'" @click="touchItem(1)">
          <div>配件信息</div>
        </div>
        <div :class="actItem == 2 && 'actItem'" @click="touchItem(2)">
          <div>配件流转</div>
        </div>
      </div>
      <div v-if="act != 1" :style="actItem == 1 && 'opacity: 0;transform: scale(0.9);'" class="flow-path" @scroll="listScroll">
        <van-divider v-if="!list.length" >暂无数据</van-divider>
        <template v-for="(it, i) in list">
          <div :key="i">
            <!-- <div style="display: flex; align-items: center">
              <img :src="it.icon" />
            </div> -->
            <div style="display: flex; align-items: center">
              <img :src="it.action == 1 ? require('@/assets/images/in.png') : require('@/assets/images/out.png')" />
              <div class="line-top" :style="'background: '+(it.action == 1 ? '#2e8dff' : '#f38f2f')" v-if="(i != 0)"></div>
              <div class="line-bottom" :style="'background: '+(it.action == 1 ? '#2e8dff' : '#f38f2f')" v-if="(i != (list.length - 1))"></div>
            </div>
            <div>
              <div>接收方公司：{{it.obj_part}}</div>
              <div>姓名：{{it.obj_name}}</div>
              <div>操作：{{it.action == 1 ? '入库' : '出库'}}</div>
              <div>手机：{{it.obj_phone}}</div>
              <div>地址：{{it.obj_address}}</div>
              <div>创建时间：{{it.created_at}}</div>
            </div>
          </div>
        </template>
        <van-divider v-if="noMore && list.length">到底了</van-divider>
      </div>
      <div v-if="act != 2" :style="actItem == 2 && 'opacity: 0;transform: scale(0.9);'" class="bottle-info">
        <div v-for="(it, i) in infoList" :key="i">
          <div><img :src="it.icon" alt="" /></div>
          <div>{{ it.name }}</div>
          <div>
            <span :style="it.text == 'policy_no' && 'border-bottom: 1px solid #2E8DFF;color:#2E8DFF;'">{{ infoObj[it.text] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import { getPartsFlow, getBottleRoam } from "@/api/search.js";
import { Toast } from "vant";
export default {
  components: {
    mobileHeader,
  },
  data() {
    return {
      actItem: 1,
      act: 1,
      list: [],
      infoList: [
        {
          icon: require("@/assets/images/feijuminranqiyonghu.png"),
          name: "出厂单位",
          text: "company",
        },
        {
          icon: require("@/assets/images/riqi.png"),
          name: "有效期，单位年",
          text: "expired",
        },
        {
          icon: require("@/assets/images/gongneng.png"),
          name: "产品型号",
          text: "model",
        },
        {
          icon: require("@/assets/images/gerenzhongxin-shiyongbangzhu.png"),
          name: "产品规格",
          text: "size",
        },
        {
          icon: require("@/assets/images/riqi_1.png"),
          name: "出厂日期",
          text: "release",
        },
        {
          icon: require("@/assets/images/feijuminranqiyonghu.png"),
          name: "批次",
          text: "ord",
        },
        {
          icon: require("@/assets/images/ranqixieloubaojingqi.png"),
          name: "序列号",
          text: "series",
        },
      ],
      infoObj: {},
      //1：门店，2：充装，3：监测，4：回收，5：使用，6：送气，7：报废，8：其他
      stateObj: {
        1: "门店",
        2: "充装",
        3: "监测",
        4: "回收",
        5: "使用",
        6: "送气",
        7: "报废",
        8: "其他",
        9: "自提送回",
        10: "到店自提",
      },
      stateObjs: {
        1: {
          icon: require("@/assets/images/chongzhuangzhan.png"),
          state: "门店"
        },
        2: {
          icon: require("@/assets/images/ranqichupei-icon.png"),
          state: "充装"
        },
        3: {
          icon: require("@/assets/images/chaxun.png"),
          state: "监测"
        },
        4: {
          icon: require("@/assets/images/cheliangjianguan-icon.png"),
          state: "回收"
        },
        5: {
          icon: require("@/assets/images/yonghu.png"),
          state: "使用"
        },
        6: {
          icon: require("@/assets/images/cheliangjianguan-1.png"),
          state: "送气"
        },
        7: {
          icon: require("@/assets/images/jijubaofeishenqing-icon.png"),
          state: "报废"
        },
        8: {
          icon: require("@/assets/images/qita.png"),
          state: "其他"
        },
        9: {
          icon: require("@/assets/images/zitish.png"),
          state: "自提送回"
        },
        10: {
          icon: require("@/assets/images/ziti.png"),
          state: "到店自提"
        },
      },
      BG: null,
      bottleId: null,
      loading: false,
      noMore: false,
      page: 1,
    };
  },
  created() {
    this.bottleId = this.$route.query.bottleId || this.$route.params.bottleId;
    this.BG = this.bottleId.substr(1, 2)
    this.getPartsFlow()
  },
  watch: {
    actItem(val){
      const time = setTimeout(_=>{
        this.act = val
        clearTimeout(time)
      }, 100)
    }
  },
  methods: {
    async touchItem(actItem) {
      if(this.actItem == actItem)return false
        this.getPartsFlow()
      // if(actItem == 1){
      // }else{
      //   this.list = []
      //   this.page = 1
      //   this.noMore = false
      //   await this.getBottleRoam()
      //   this.page += 1
      //   this.getBottleRoam()
      // }
      this.actItem = actItem;
    },
    listScroll(e){
      if(this.loading)return false
      if(this.noMore)return false
      const dom = e.target
      const scrollTop = dom.scrollTop
      const windowHeight = dom.clientHeight
      const scrollHeight = dom.scrollHeight
      if(scrollTop + windowHeight > scrollHeight - 50){
        console.log('到底了')
        this.page += 1
        this.getBottleRoam();
      } 
    },
    async getPartsFlow() {
      const { code, data, msg } = await getPartsFlow({
        bottleId: this.bottleId,
      });
      if (code != 200) return Toast({ message: msg || '服务器错误' });
      this.infoObj = data.info;
      this.list = data.flow;
    },
    async getBottleRoam() {
      this.loading = true
      const {code, data:{data, total}, msg} = await getBottleRoam({bottleId: this.bottleId,page : this.page})
      if(code != 200)return Toast({message: msg || '服务器错误'})
      const list = this.list
      console.log(data,123456)
      data.map(it => {
        list.push({...this.stateObjs[it.type], type: it.type, step_name: it.step_name, time: it.time, text: it.txt,})
      })
      this.loading = false
      this.list = list
      this.list.length >= total && (this.noMore = true)
    },
  },
};
</script>

<style lang="scss">
.page{
  height: 100vh;
  overflow: auto;
}
.header-img {
  width: 92.5vw;
  height: 37.9vw;
  margin-left: 3.6vw;
  position: sticky;
  top: 3.6vw;
  border-radius: 1.8vw;
}
.content {
  width: 94.7vw;
  height: 148.7vw;
  margin-left: 2.8vw;
  margin-top: -16.4vw;
  transition: all 0.2s;
  position: relative;
  min-height: 45vw;
  max-height: calc(100vh - 29vw);
  & > .bg{
    width: calc(100% - 9vw);
    height: calc(100% - 5vw);
    background: #FFFFFF;
    box-shadow: 0px 0px 4.9vw 0px rgba(199, 194, 194, 0.44);
    border-radius: 2.8vw;
    position: absolute;
    left: 0;
    top: 0;
    margin: 0 4.5vw;
    margin-top: 5vw;
  }
  & > img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .tab-box {
    height: 18.9vw;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    padding: 0 5vw;
    padding-top: 5.6vw;
    box-sizing: border-box;
    & > .actItem {
      color: #2e8dff;
      & > div {
        width: fit-content;
        border-bottom: 2px solid #378ff5;
        margin: 0 auto;
      }
    }
    & > div {
      flex: 1;
      font-size: 5.3vw;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #a29c9c;
      text-align: center;
      position: relative;
      transition: all 0.1s;
      & > div {
        transition: all 0.2s;
      }
    }
    & > div + div::before {
      content: "";
      width: 1px;
      height: 100%;
      position: absolute;
      left: 0;
      background: #ccc9ca;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      background: #ccc9ca;
      width: calc(100% - 16.6vw);
      left: 8.3vw;
      height: 1px;
      position: absolute;
    }
  }
  .flow-path {
    position: absolute;
    z-index: 1;
    padding: 4vw 10vw;
    transform: scale(1);
    transition: all 0.2s;
    width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 50vw);
    overflow: auto;
    & > div + div{
      // margin-top: 10px;
      padding-top: 10px;
    }
    & > div {
      display: flex;
      align-items: center;
      margin: 0;
      position: relative;
      & > div:nth-child(1) {
        width: 10.7vw;
        img {
          width: 5.3vw;
          height: 5.3vw;
        }
      }
      & > div:nth-child(2) {
        // width: 7vw;
        font-size: 3.2vw;
        position: relative;
        flex: 1;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
        img {
          width: 4.6vw;
          height: 4.6vw;
          position: relative;
          z-index: 10;
        }
      }
      & > div:nth-child(3) {
        width: 15vw;
        font-size: 3.2vw;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2a2929;
      }
      & > div:nth-child(4) {
        font-size: 2.9vw;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2a2929;
        flex: 1;
      }
    }
    // & > div + div {
    //   & > div:nth-child(2) {
    //     &::before {
    //       content: "";
    //       background: #d3d2d5;
    //       width: 1px;
    //       height: 10vw;
    //       position: absolute;
    //       bottom: 2vw;
    //       left: calc(2.3vw - 0.5px);
    //     }
    //   }
    // }
  }
  .bottle-info {
    padding: 3vw 10vw;
    transition: all 0.2s;
    // position: absolute;
    transform: scale(1);
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    & > div {
      display: flex;
      align-items: center;
      height: 7.8vw;
      & > div:nth-child(1) {
        width: 6.4vw;
        display: flex;
        align-items: center;
        img {
          width: 4.5vw;
          height: 4.5vw;
        }
      }
      & > div:nth-child(2) {
        font-size: 3.2vw;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2a2929;
      }
      & > div:nth-child(3) {
        flex: 1;
        text-align: end;
        font-size: 3.2vw;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2a2929;
      }
    }
  }
}
.line-top{
  content: "";
  height: 50%;
  width: 2px;
  top: 0;
  left: 2.5vw;
  position: absolute;
  background: #2e8dff;
}
.line-bottom{
  content: "";
  height: calc(50% + 10px);
  width: 2px;
  top: 50%;
  left: 2.5vw;
  position: absolute;
  background: #2e8dff;
}
@media screen and (min-width: 1100px) {
  .content{
    min-height: fit-content;
    max-height: fit-content;
    height: fit-content!important;

    .flow-path{
      height: fit-content;
      position: relative;
    }
  }
}
</style>